import ProviderStatus from './provider-status';

export default ProviderStatus;
